import React from "react";
import { Route, Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { useSelector } from "react-redux";

export const PrivateRoute = withRouter(
  ({ component: RouteComponent, ...rest }) => {
    const loggedIn = useSelector(state => !!state.auth.token);
    return (
      <Route
        {...rest}
        render={routeProps =>
          loggedIn ? (
            <RouteComponent {...routeProps} />
          ) : (
            <Redirect to="/login" />
          )
        }
      />
    );
  }
);
